import React, {Fragment} from 'react';
import {Today, Activities, Popup, Icon, Icons, Collaboration, Diary} from 'components';
import {modal, capitalize, useNamedSelector} from 'helpers';
import {duplicate, hold, remove, toggle} from 'store/activities';

export function Menu(props) {
  return (
    <Popup.Menu {...props} Menu={MenuContent} />
  );
}

export function MenuHandle(props) {
  return (
    <Popup.Menu.Handle Menu={MenuContent} {...props} />
  );
}

function MenuContent(props) {
  const { activity, context, contextDate, status, popup, type, ritual, attributes, edit, diary } = props;
  const timer = useNamedSelector('calendar.timer', { id: activity.id, date: contextDate });
  return (
    <Fragment>
      { type == 'activity' &&
        <Popup.Menu.Item
          icon={status == 'Completed' ? 'undo' : 'check'}
          onClick={() => toggle(activity)}
          className={status == 'Completed' ? '' : 'primary'}
          children={status == 'Completed' ? 'Uncomplete' : 'Complete'}
        />
      }
      { contextDate &&
        <Fragment>
          <Activities.StatusMenu {...props} nested />
          <Popup.Menu.Separator />
          <Popup.Menu.Item onClick={popup.redirect(Activities.TimerPopup)}>
            <Icon name={timer.unit} isBlinking Sub={timer.isRunning && Icons.Circle} />
            { timer.isRunning ? (timer.unit == 'stopwatch' ? 'Stopwatch' : 'Timer')  : 'Start '.concat(capitalize(ritual ? 'ritual' : type)) }
          </Popup.Menu.Item>
        </Fragment>
      }
      { /(activities|habits|routines)\/\d/.test(attributes.navLink)
        ? <Popup.Menu.Item icon="pencil" to={attributes.navLink}>Edit</Popup.Menu.Item>
        : <Popup.Menu.Item icon="pencil" onClick={edit}>Edit</Popup.Menu.Item>
      }
      { !activity.repeatType && <Popup.Menu.Item icon="duplicate" onClick={() => duplicate(activity)}>Duplicate</Popup.Menu.Item> }

      <Popup.Menu.Item icon="diary" onClick={modal(diary?.length ? Diary.Sidebar : Diary.EditForm, {context: {activity}})}>
        {diary?.length ? 'View' : 'Add'} Journal
      </Popup.Menu.Item>

      { !context?.onCalendar &&
        <Fragment>
          <Popup.Menu.Item icon="hold" onClick={() => hold(activity)}>{ status == 'On Hold' ? 'Unhold' : 'Hold' }</Popup.Menu.Item>
          { parseFloat(activity.numericalTarget) > 0 &&
            <Popup.Menu.Item icon="chart" onClick={modal(Today.TrackingChart, activity)}>Tracking history</Popup.Menu.Item>
          }
          <Collaboration.MenuItem id={activity.id} context="activities" />
        </Fragment>
      }

      { (type == 'activity' || !contextDate) &&
        <Fragment>
          <Popup.Menu.Separator />
          <Popup.Menu.DeleteItem onConfirm={() => remove(activity)}>Delete</Popup.Menu.DeleteItem>
        </Fragment>
      }
    </Fragment>
  );
}
